



import { Component, Vue, Prop, Watch } from "vue-property-decorator"

@Component({
  name: "Content",
  components: {}
})
export default class Content extends Vue {
  @Prop({ type: String, default: "" })
  content

  @Prop({ type: Array, default: () => [] })
  videos

  destroyed() {
    Array.isArray(window.globalVideoList) &&
      window.globalVideoList.forEach(obj => {
        if (obj._player) {
          obj._player.destroy()
        }
      })
    window.globalVideoList = null
  }

  checkImg() {
    const imgs = document.querySelector("#editor").querySelectorAll("img")
    for (let i = 0; i < imgs.length; i++) {
      imgs[i].addEventListener(
        "error",
        e => {
          if (
            !(e.target as any).currentSrc.includes(
              "?x-oss-process=image/format,webp"
            )
          ) {
            imgs[i].src = imgs[i].src + "?x-oss-process=image/format,webp"
          }
        },
        { once: true }
      )
    }
  }

  @Watch("content", { immediate: true })
  onContent(c) {
    if (c && !this.$isServer) {
      setTimeout(() => {
        if (typeof window !== "undefined" && window.initVideo) {
          window.initVideo()
          window.judgeVideoStatus(this.videos)
          window.initPlaceholderVideo()
        }
        this.checkImg()
      }, 100)
    }
  }
}
